import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { Heading } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Heading.css';

import './HomeCardBack.scss';

const THINGS_WE_LIKE_KEY = 'homecard.extended.we_like';
const KEEP_IN_MIND_KEY = 'homecard.extended.in_mind';

const HomeCardBackList = ({ list, titleKey }) =>
  list.length ? (
    <Fragment>
      <Heading
        level="3"
        size="small"
        theme="light"
        text={trans(titleKey)}
        align="left"
      />
      <ul className="homecard-backside__list">
        {list.map(text => (
          <li>{text}</li>
        ))}
      </ul>
    </Fragment>
  ) : null;

HomeCardBackList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
  titleKey: PropTypes.string.isRequired
};

HomeCardBackList.defaultProps = {
  list: []
};

class HomeCardBack extends PureComponent {
  static propTypes = {
    thingsWeLike: PropTypes.arrayOf(PropTypes.string),
    thingsToKeepInMind: PropTypes.arrayOf(PropTypes.string)
  };

  static defaultProps = {
    thingsWeLike: [],
    thingsToKeepInMind: []
  };

  render() {
    return (
      <div className="homecard-backside">
        <HomeCardBackList
          list={this.props.thingsWeLike}
          titleKey={THINGS_WE_LIKE_KEY}
        />
        <HomeCardBackList
          list={this.props.thingsToKeepInMind}
          titleKey={KEEP_IN_MIND_KEY}
        />
      </div>
    );
  }
}

export default HomeCardBack;
